import React from "react";
import PropTypes from "prop-types";
import { useVoltState } from "@mqd/volt-toolbox/src";
import { LeftNavLink } from "./left-nav-link.js";
import { LeftNavMenu } from "./left-nav-menu.js";
import css from "./left-nav.module.css";
import { TNavLinks } from "./types.js";
export function LeftNavContent({ activePath, header, links, persist }) {
  const { showHeader } = useVoltState((state) => state.leftNav);
  return /* @__PURE__ */ React.createElement("div", { className: css.leftNavContent }, header && showHeader && /* @__PURE__ */ React.createElement("header", { className: css.leftNavHeader }, header), /* @__PURE__ */ React.createElement("nav", { className: css.leftNavLinks }, links.map((link) => {
    const { children, title } = link;
    const isMenu = Boolean(children);
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: title }, isMenu ? /* @__PURE__ */ React.createElement(
      LeftNavMenu,
      {
        activePath,
        persist,
        ...link
      }
    ) : /* @__PURE__ */ React.createElement(LeftNavLink, { activePath, ...link }, title));
  })));
}
LeftNavContent.propTypes = {
  activePath: PropTypes.string,
  header: PropTypes.node,
  links: TNavLinks,
  persist: PropTypes.bool,
  setActiveSections: PropTypes.func
};
LeftNavContent.defaultProps = {
  activePath: null,
  links: [],
  setActiveSections: () => {
  }
};
LeftNavContent.displayName = "LeftNav.Content";
